import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';

import { breakpoint } from '../theme/breakpoint';
import PaddedBox from '../padded-box';
import { focusStyles } from './focus';

export const squareBulletPoints = css`
  /**
  * Square bulletpoints, outlined for nested lists
  */
  padding-left: 0;
  list-style: none;

  li {
    position: relative;
    padding-left: 26px;

    &::before {
      content: ' ';
      position: absolute;
      top: 8px;
      left: ${({ theme }) => theme.spacing.tiny};
      display: block;
      width: ${({ theme }) => theme.spacing.tiny};
      height: ${({ theme }) => theme.spacing.tiny};
      background: ${({ theme }) => theme.palette.standardText};
    }

    ul {
      padding-left: 0;
      list-style: none;
      li:before {
        background: transparent;
        border: 1px solid ${({ theme }) => theme.palette.standardText};
      }
    }
  }
`;

// press release, policy library, and updates, insights and impact listings
export const List = styled.div`
  background: ${({ theme }) => theme.palette.lightBackground};
  padding-top: ${({ theme }) => theme.spacing.medium};
`;

export const PressItem = styled(PaddedBox)`
  position: relative;
  padding-top: ${({ theme }) => theme.spacing.tiny};
  padding-bottom: ${({ theme }) => theme.spacing.medium};
  padding-left: ${({ theme }) => theme.spacing.xlarge};
  padding-right: ${({ theme }) => theme.spacing.xlarge};

  &:hover {
    box-shadow: ${({ theme }) => theme.boxshadow.standard};
  }

  &:active {
    ${focusStyles};
  }

  ${(props) =>
    props.includesImage &&
    css`
      padding-top: ${({ theme }) => theme.spacing.medium};
      display: flex;
      flex-direction: column;

      ${breakpoint.tablet`
        flex-direction: row;
      `};
    `}
`;

export const PostedDate = styled.p`
  color: ${({ theme }) => theme.palette.secondaryText};
`;

export const ArrowIcon = styled(SVG)``;

export const StyledDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  flex-wrap: wrap;
`;

export const Tag = styled.p`
  position: relative;
  background: ${({ theme }) => theme.palette.darkBackground};
  color: ${({ theme }) => theme.palette.white};
  height: 40px;
  width: fit-content;
  padding: 7px 15px 0;
  margin: ${({ theme }) => theme.spacing.large} 0;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  &:before {
    content: '';
    position: absolute;
    right: -20px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 20px solid ${({ theme }) => theme.palette.darkBackground};
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }
`;
